import React from "react";

import getLocalData from "../../lib/getLocalData";
import mixpanel from "../../lib/mixPanel";

import getCompletedStatus from "../../lib/getRestaurantCompletedStatus";

const resizedUrl = url => {
  let replacedWidth = url.replace("[WIDTH]", "600");
  const newUrl = replacedWidth.replace("[HEIGHT]", "340");
  return newUrl;
};

const handleClickRestaurant = (
  restaurantSlug,
  restaurantPostalCode,
  adminWard,
  city,
  index,
  restaurantName
) => {
  mixpanel.track("Restaurant Click", { _rowNumber: index });
  let href;
  if (restaurantSlug) {
    mixpanel.track("Restaurant Detail Screen", {
      _source: "Restaurants Tab",
      _restaurantName: restaurantName
    });
    const localdata = getLocalData("deliveryDetails");
    let preOrder, postalCode;
    if (localdata) {
      preOrder = localdata.preOrder || "";
      postalCode = localdata.postalCode || "";
    }
    href = `/restaurant/${city}/${adminWard}/${restaurantSlug}/?postcode=${postalCode ||
      restaurantPostalCode}&time=${preOrder || "now"}`;
  }
  if (href) {
    window.location.href = href;
  }
};

const ListItem = ({ restaurant, index, isReward, isCustom, customTag }) => {
  const completedStatus = getCompletedStatus({
    restaurantStatusCode: restaurant.restaurantStatusCode,
    restaurantStatusParams: restaurant.restaurantStatusParams
  });
  const handleBanner = () => {
    if (isReward) {
      return (
        <div className="rewards rew1">{`${restaurant.deal.reward_percent}% Reward`}</div>
      );
    } else if (isCustom && customTag) {
      return <div className="custom custom1">{customTag}</div>;
    } else return null;
  };
  const avgScore = restaurant.avgScore;
  const avgClassName = restaurant && `avg-score s${parseInt(avgScore)}`;
  return (
    (restaurant && (
      <div
        className={`items ${(completedStatus && "offline") || ""}`}
        onClick={() =>
          handleClickRestaurant(
            restaurant.slugName,
            restaurant.restaurantAddressPostalCode,
            restaurant.restaurantAddressSlugAdminWard,
            restaurant.restaurantAddressSlugCityName,
            index,
            restaurant.name
          )
        }
      >
        <div
          className="img"
          style={{
            background: `url(${resizedUrl(
              restaurant.picture.url
            )}) center no-repeat`
          }}
        >
          {(completedStatus && (
            <div className="rest-offline splitted">{completedStatus}</div>
          )) || <noscript />}
          {(avgScore && (
            <p className={avgClassName}>
              <span>{parseFloat(restaurant.avgScore).toFixed(1)}</span>
            </p>
          )) || <noscript />}
          {(!completedStatus && handleBanner()) || <noscript />}
        </div>
        <div className="desc">
          <a href="javascript: void(0)" className="d-flex align-items-center">
            {(restaurant.isNew && (
              <label className="label label-blue">New</label>
            )) || <noscript />}
            <h5>{restaurant.name}</h5>
          </a>
          {(restaurant.deliveryType === "IN_HOUSE_DELIVERY" && (
            <>
              {restaurant.types && restaurant.types.length && (
                <div className="d-flex type-with-min">
                  {restaurant.minOrderEnabled && (
                    <p>
                      Min. £{parseFloat(restaurant.minOrderAmount).toFixed(2)}
                      &nbsp;|&nbsp;
                    </p>
                  )}
                  {restaurant.types.map(
                    (type, i) =>
                      (restaurant.types.length !== i + 1 && (
                        <p key={i}>{`${type.name},`}&nbsp;</p>
                      )) || <p key={i}>{type.name}</p>
                  )}
                </div>
              )}
              <div className="d-flex-hide-desktop">
                <div className="d-flex align-items-center mb-10px">
                  <div className="listitem-delivered-by">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19"
                      height="16"
                      viewBox="0 0 19 16"
                    >
                      <g fill="none" fillRule="evenodd">
                        <path
                          fill="#8492A6"
                          fillRule="nonzero"
                          d="M16.185 9.01a2.149 2.149 0 0 0 .431-2.115l-1.118-3.354.903.18a.273.273 0 0 0 .326-.267V1.274a.273.273 0 0 0-.359-.26l-2.412.805h-1.592a.273.273 0 0 0-.273.273v1.09c0 .151.122.274.273.274h.845l.176 1.671a6.134 6.134 0 0 1-1.944 5.147h-1.113a2.042 2.042 0 0 1-1.453-.602 2.041 2.041 0 0 1-.602-1.454v-.126c0-.602.489-1.091 1.09-1.091a.82.82 0 0 0 0-1.636H5.819v-.546h.273c.15 0 .273-.122.273-.273V1.273A.273.273 0 0 0 6.09 1H2.818a.273.273 0 0 0-.273.273v3h-.272A.273.273 0 0 0 2 4.545v3.273c0 .15.122.273.273.273H3.28A2.997 2.997 0 0 0 2 10.545v1.91c0 .15.122.272.273.272h.323a2.987 2.987 0 0 0 2.95 2.455 2.987 2.987 0 0 0 2.948-2.455h.324c.151 0 .273-.122.273-.272 0-.093-.007-.183-.014-.273h2.755a3.6 3.6 0 0 0-.014.273c0 .15.122.272.273.272h.324a2.987 2.987 0 0 0 2.949 2.455 2.987 2.987 0 0 0 2.949-2.455h.323c.151 0 .273-.122.273-.272a3.549 3.549 0 0 0-2.724-3.446zM7.823 7.544H5.818V7h2.33a1.639 1.639 0 0 0-.325.545zm1.54-1.636a.273.273 0 0 1 0 .546H5.819v-.546h3.546zM4.183 1.545h.545v1.091h-.545v-1.09zm-1.091 0h.545V2.91c0 .15.122.273.273.273H5c.15 0 .273-.122.273-.273V1.545h.545v2.728H3.091V1.545zm.545 3.273h.546V5.91h-.546V4.82zm-1.09 2.727V4.818h.545v1.364c0 .15.122.273.273.273h1.09c.151 0 .273-.123.273-.273V4.818h.546v2.727H2.545zm3 7.091a2.443 2.443 0 0 1-2.392-1.909h.563a1.901 1.901 0 0 0 1.828 1.364c.858 0 1.592-.562 1.83-1.364h.562a2.443 2.443 0 0 1-2.392 1.91zM4.3 12.727H6.79a1.355 1.355 0 0 1-1.246.818c-.554 0-1.033-.33-1.245-.818zm-1.742-.545a3.004 3.004 0 0 1 2.987-2.727c1.563 0 2.85 1.2 2.988 2.727H2.558zm6.434-.546A3.55 3.55 0 0 0 5.545 8.91a3.543 3.543 0 0 0-3 1.665v-.029A2.457 2.457 0 0 1 5 8.091h2.727v.126c0 .695.27 1.348.762 1.84a2.583 2.583 0 0 0 1.839.761h1.217a.273.273 0 0 0 .182-.069 6.68 6.68 0 0 0 2.2-5.68l-.201-1.916a.272.272 0 0 0-.271-.244h-.819v-.545H14c.03 0 .058-.005.086-.014l2.096-.699v1.47l-.882-.176-.223-.668-.517.173 1.54 4.618c.054.165.082.337.082.512 0 .432-.169.839-.474 1.145l-.192.192c-.051-.002-.101-.008-.152-.008a3.55 3.55 0 0 0-3.447 2.727H8.992zm6.372 3a2.443 2.443 0 0 1-2.392-1.909h.563a1.901 1.901 0 0 0 1.829 1.364c.857 0 1.591-.562 1.828-1.364h.563a2.443 2.443 0 0 1-2.391 1.91zm-1.246-1.909h2.491a1.355 1.355 0 0 1-1.246.818c-.554 0-1.033-.33-1.245-.818zm-1.742-.545a3.004 3.004 0 0 1 2.988-2.727c1.562 0 2.85 1.2 2.987 2.727h-5.975z"
                        />
                        <path
                          fill="#8492A6"
                          fillRule="nonzero"
                          d="M13 11.534l.506.205a1.902 1.902 0 0 1 1.77-1.194V10A2.445 2.445 0 0 0 13 11.534zM3 11.534l.506.205a1.902 1.902 0 0 1 1.77-1.194V10A2.445 2.445 0 0 0 3 11.534z"
                        />
                        <circle
                          cx="4.227"
                          cy="4.227"
                          r="4.227"
                          fill="#EFF2F7"
                        />
                        <path
                          fill="#8492A6"
                          fillRule="nonzero"
                          d="M3.648 0A3.654 3.654 0 0 0 0 3.648a3.654 3.654 0 0 0 3.648 3.649 3.654 3.654 0 0 0 3.649-3.649A3.654 3.654 0 0 0 3.648 0zm0 .755a2.888 2.888 0 0 1 2.894 2.893 2.888 2.888 0 0 1-2.894 2.894A2.888 2.888 0 0 1 .755 3.648 2.888 2.888 0 0 1 3.648.755zm0 .629a.377.377 0 0 0-.377.377v1.887c0 .14.076.261.189.327l1.415.817a.377.377 0 1 0 .377-.652l-1.226-.708v-1.67a.377.377 0 0 0-.378-.378z"
                        />
                      </g>
                    </svg>
                  </div>
                  <p>Delivery by {restaurant.name}</p>
                </div>
                <p>
                  <img className="listitem-mile" src="/svg/location.svg" />{" "}
                  {restaurant.distance} mi
                </p>
              </div>
            </>
          )) || (
            <>
              {restaurant.types && restaurant.types.length && (
                <div className="d-flex">
                  {restaurant.types.map(
                    (type, i) =>
                      (restaurant.types.length !== i + 1 && (
                        <p key={i}>{`${type.name},`}&nbsp;</p>
                      )) || <p key={i}>{type.name}</p>
                  )}
                </div>
              )}
              <div className="d-flex align-items-center justify-content-between d-flex-hide-desktop">
                <p className="bold-destkop">
                  {restaurant.minOrderEnabled &&
                    `Min. £${parseFloat(restaurant.minOrderAmount).toFixed(2)}`}
                </p>
                <p>
                  <img className="listitem-mile" src="/svg/location.svg" />{" "}
                  {restaurant.distance} mi
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    )) || <div>No found item</div>
  );
};

export default ListItem;
